<template>
  <div>
    <Nav :login="isLogin" :username="currentUsername" />
    <div class="home">
      <div class="banner">
        <div class="banner-img">
          <img src="./images/banner-256.png" class="banner-small" />
          <img src="./images/banner-336.png" class="banner-big" />
          <div class="banner-content">
            <h1>远程同传</h1>
            <div class="banner-intro">平台在线连接远程同传译员及活动举办方，观众使用手机扫码即可在手机端获取优质同传服务</div>
            <a href="/tongchuan.do?method=tongchuanOrderInfo" class="creat">创建会议</a>
            <!-- <a href class="contact">联系我们</a> -->
          </div>
        </div>
      </div>
      <div class="compare">
        <div class="old">
          <h2>传统同传</h2>
          <h5>
            译员到场进行同传，按天排期，综合费用
            <span>10000元起</span>
          </h5>
          <ul class="compare-detail">
            <li>
              <div class="line"></div>按天计费
            </li>
            <li>
              <div class="line"></div>承担译员往返路费/住宿费用
            </li>
            <li>
              <div class="line"></div>承担设备租赁/损耗费用
            </li>
            <li>
              <div class="line"></div>观众现场领取耳机收听
            </li>
            <li>
              <div class="line"></div>2位译员现场同传
            </li>
            <li>
              <div class="line"></div>无PPT同步、字幕等附加服务
            </li>
          </ul>
        </div>
        <div class="vs-logo">
          <img src="./images/vs.png" />
        </div>
        <div class="new">
          <h2>远程同传</h2>
          <h5>
            远程连接译员，按小时计费，畅享<span>经济优质</span>的同传服务
          </h5>
          <ul class="compare-detail">
            <li>
              <div class="line"></div>按小时计费
            </li>
            <li>
              <div class="line"></div>免去译员行程费用
            </li>
            <li>
              <div class="line"></div>免去昂贵设备费用
            </li>
            <li>
              <div class="line"></div>观众手机扫描二维码即可获取同传
            </li>
            <li>
              <div class="line"></div>2位译员远程接入配合同传
            </li>
            <li>
              <div class="line"></div>PPT播放、字幕展示、录音等多种附加服务
            </li>
          </ul>
          <div class="hint">
            <img src="./images/hint.png" class="hint-logo" />
            <span class="hint-slogan">方便快捷，性价比高</span>
          </div>
        </div>
      </div>

      <div class="process">
        <h2>远程同传流程</h2>
        <h6>改变传统同传模式，让更多人享受经济优质的同传服务</h6>
        <div class="liner"></div>
        <div class="process-content">
          <img src="./images/process.png" class="process-img" />
          <div class="process-frame">
            <div class="trangle"></div>
            <div class="process-frame-head">
              <h2>FAQs</h2>
              <!-- <span class="more">了解更多</span> -->
            </div>
            <ul class="process-req">
              <li
                v-for="(item,index) in reqLists"
                :key="index"
                @click="toggle(index)"
                :class="{'last':index==4}"
              >
                <span class="requests">{{item.req}}</span>
                <!-- <span class="plus"  :class="{'active':item.isOpen}"></span>
                <span class="process-show" :class="{'process-hid':!item.isOpen}">{{item.ans}}</span>-->
                <span class="plus" :class="{'active': num ==index}"></span>
                <span class="process-show" :class="{'process-hid': num !==index}">{{item.ans}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="senators">
        <h2>优质译员</h2>
        <h6>有道同传具备多领域、多语种高端口译人才储备，我们对译员执行严格测试、多轮淘汰机制，确保每名译员都能提供高品质的同传服务</h6>
        <div class="liner"></div>
        <div class="senators-intro">
          <div class="senator first">
            <img src="./images/Riley.png" class="senator-img" />
            <div class="senator-name">Riley</div>
            <div class="senator-title">
              中山大学（BA）| 蒙特雷国际研究院（MA）| 高级口译证书
              <br />精通：英语、中文、日语、西班牙语
              <br />专长：外交、环境、金融、医药、科技、文化、时尚
            </div>
            <div class="senator-liner"></div>
            <div class="senator-experience">
              <p class="title">部分会议口译经历</p>
              <p class="detail">
                2018.2 圣罗兰 2018 秋冬巴黎时装周
                <br />2017.11 暴雪嘉年华官方直播神话频道
                <br />2017.9 美国旧金山湾区经济合作与发展论坛
                <br />2016.5 中国(北京)国际服务贸易交易会研讨会
                <br />2014.11 哈佛商学评论与《财经》2014 营销战略领袖峰会
                <br />2013.10 核不扩散与反恐怖模拟谈判
              </p>
            </div>
          </div>
          <div class="senator">
            <img src="./images/crystal.png" class="senator-img" />
            <div class="senator-name">Crystal</div>
            <div class="senator-title">
              CATTI2 | 曾任上海赛科首席口译员 | 上海世博会中国馆首席VIP口译
              <br />专长：汽车、化工、能源、医药、电子、航空航天、政府、金融|快销、IT
            </div>
            <div class="senator-liner"></div>
            <div class="senator-experience">
              <p class="title">部分VIP客户</p>
              <p class="detail">
                美国国务卿希拉里·克林顿 | Hillary Clinton
                <br />英国前首相托尼·布莱尔 | Tony Blair
                <br />外交部副部长王光亚
                <br />奥地利前财政部长 | Josef Proell
                <br />新西兰总理约翰·凯伊 | John Key
                <br />奥斯卡影帝罗伯特·德尼罗 | Robert Deniro
                <br />NBA球星路易斯·斯科拉 | Luis Scola
                <br />谷歌大中华区总裁石博盟 | Scott Beaumont
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="cases">
        <h2>合作案例</h2>
        <div class="liner"></div>
        <div class="container">
          <div class="case border">
            <img src="./images/montessori.png" class="case-img" />
            <div class="title-ch">2018 蒙台梭利会议</div>
            <div class="title-en">Montessori Conference 2018</div>
          </div>
          <div class="case border">
            <img src="./images/AI.png" class="case-img" />
            <div class="title-ch">2019 全球人工智能与机器人峰会</div>
            <div class="title-en">Global Artificial Intelligence and Robotics Summit</div>
          </div>
          <div class="case last-case">
            <img src="./images/36kr.png" class="case-img" />
            <div class="title-ch">36氪Wise大会</div>
            <div class="title-en">36Kr Wise Conference</div>
          </div>
          <div class="case border">
            <img src="./images/blizzard.png" class="case-img" />
            <div class="title-ch">暴雪嘉年华官方直播</div>
            <div class="title-en">BlizzCon Live Online</div>
          </div>
          <div class="case border">
            <img src="./images/leifeng.png" class="case-img" />
            <div class="title-ch">雷锋网教育峰会</div>
            <div class="title-en">LeiPhone Education Summit</div>
          </div>
          <div class="case last-case">
            <img src="./images/iphone.png" class="case-img" />
            <div class="title-ch">2018 Apple发布会</div>
            <div class="title-en">Apple Special Event 2018</div>
          </div>
        </div>
      </div>
      <div id="ServiceBox1" v-show="isOpen">
        <div class="close-wrap">
          <span id="ServiceBox1-close" @click="close"></span>
        </div>
        <span class="tel">400-6608-163</span>
        <span id="onlineService" class="clog-js" data-act="online_consult">
          <span id="live800iconlink" @click="onlineSevice">在线客服</span>
        </span>
        <span id="weixinService" class="clog-js" data-act="weixin_consult">
          <span id="weixinLogo"></span>
          <div class="weixin-text">
            微信扫一扫
            <br />实时接收订单消息
          </div>
        </span>
      </div>
      <div id="small-service-box" v-show="isClose" @click="open">
        <span></span>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav/index.vue'
import Footer from '@/components/Footer/index.vue'
import axios from 'axios'

export default {
  name: 'home',
  components: {
    Nav,
    Footer
  },
  data () {
    return {
      num: -1,
      reqLists: [
        {
          req: '活动举办方需要什么设备？',
          ans: '仅需1台笔记本电脑及1根音频接线收集活动现场音频'
        },
        {
          req: '译员如何进行同传？',
          ans: '通过有道云平台远程收听活动现场原声进行同声传译'
        },
        {
          req: '观众需要准备什么？',
          ans: '仅需携带个人手机和耳机'
        },
        {
          req: '在线同传如何计费？',
          ans: '按会议同传小时计费，无浪费时长'
        },
        {
          req: '有哪些免费附加服务？',
          ans: 'PPT同步直播、AI字幕、数据分析、录音等，更多服务持续上线中'
        }
      ],
      isLogin: '',
      currentUsername: '',
      isOpen: true,
      isClose: false
    }
  },
  created () {
    this.isLogin = this.login
    this.currentUsername = this.username
    this.checkLogin()
    setTimeout(() => {
      const s = document.createElement('script')
      s.type = 'text/javascript'
      s.src = 'https://qiyukf.com/script/891065c81282f8afd9e518e4e6242a74.js'
      document.body.appendChild(s)
    }, 1500)
  },
  methods: {
    checkLogin () {
      // const baseUrl="http://hts-test-zhaoyh.inner.youdao.com/"
      let url = '/activity.do?method=isLogin'
      axios.get(url).then(res => {
        console.log(res)
        if (res.data.errorCode === 0) {
          this.isLogin = true
          this.currentUsername = res.data.username
        } else {
          this.login = false
          this.currentUsername = ''
        }
      })
    },
    toggle (index) {
      // if (item.isOpen) {
      //   this.$set(item, 'isOpen', false)
      // } else {
      //   this.$set(item, 'isOpen', true)
      // }
      this.num = index
      console.log(index)
    },
    onlineSevice () {
      const kefu = document.getElementById('YSF-BTN-HOLDER')
      kefu.click()
    },
    open () {
      this.isOpen = true
      this.isClose = false
    },
    close () {
      this.isOpen = false
      this.isClose = true
    }
  }
}
</script>

<style scoped>
.banner {
  width: 100%;
background:rgba(246,247,249,1);
}
.banner-img {
  width: 1062px;
  /* height:337px; */

  margin: 0 auto;
  position: relative;
}
.banner-content {
  width: 434px;
  height: 183px;
  /* margin:0 auto; */
  text-align: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  /* margin-left:60px; */
}
.banner .creat {
  width: 120px;
  height: 36px;
  line-height: 36px;
  background: rgba(251, 58, 77, 1);
  border-radius: 4px;
  color: white;
  margin-right: 12px;
  float: left;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
}
.banner .contact {
  width: 120px;
  height: 36px;
  line-height: 36px;
  background: rgba(251, 58, 77, 0.09);
  border-radius: 4px;
  color: rgba(251, 58, 77, 1);
  font-size: 14px;
  float: left;
  text-align: center;
  cursor: pointer;
}
.banner .contact h1{
    font-weight: normal
}
.banner-intro {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(99, 105, 112, 1);
  margin-bottom: 38px;
  line-height: 26px;
}
.compare {
  width: 1062px;
  height: 344px;
  margin: 100px auto;
  position: relative;
}
.compare span {
  color: #fb3a4d;
}
.old {
  width: 510px;
  height: 344px;
  background: rgba(250, 250, 251, 1);
  border-radius: 4px 0px 0px 4px;
  float: left;
  position: relative;
}
.vs-logo img {
  position: absolute;
  top: 53px;
  left: 472px;
  width: 74px;
  height: 46px;
  z-index: 999;
}
.new {
  width: 550px;
  height: 342px;
  background: rgba(255, 255, 255, 1);
  border-radius: 0px 4px 4px 0px;
  border: 1px solid rgba(231, 231, 233, 1);
  border-left: none;
  float: left;
  position: relative;
}
h1 {
  font-size: 36px;
  font-family: FZLTZHJW--GB1-0, FZLTZHJW--GB1;
  font-weight: normal;
  color: rgba(43, 51, 61, 1);
  line-height: 36px;
  letter-spacing: 2px;
  margin-bottom: 20px;
}
h2 {
  /* width: 128px; */
  height: 32px;
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(43, 51, 61, 1);
  line-height: 32px;
  /* position: absolute; */
  top: 50px;
  left: 60px;
}
h5 {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 22px;
  position: absolute;
  top: 96px;
  left: 60px;
}
h6 {
  height: 22px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
  line-height: 22px;
  margin-top: 14px;
}
.compare h2 {
  position: absolute;
}
.compare-detail {
  position: absolute;
  top: 142px;
  left: 60px;
  text-align: left;
}
.compare li {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(99, 105, 112, 1) !important;
  line-height: 26px;
}
.hint {
  width: 200px;
  height: 38px;
  line-height: 38px;
  background: rgba(251, 58, 77, 0.08);
  border-radius: 4px;
  float: right;
  margin-top: 6px;
  margin-right: 6px;
  position: relative;
}
.hint-logo {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 8px;
  left: 15px;
}
.hint-slogan {
  position: absolute;
  left: 41px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(251, 58, 77, 1);
}
.line {
  width: 8px;
  height: 2px;
  background: rgba(178, 179, 180, 1);
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 4px;
}
.new .line {
  background: rgba(251, 58, 77, 1);
}
.process {
  margin: 100px auto;
  width: 1222px;
}

.process-img {
  width: 732px;
  height: 484px;
  float: left;
}
.process-content {
  margin: 28px auto;
  height: 484px;
  display: inline-block;
}
.process-frame {
  float: left;
  margin-left: 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 20px 40px 0px rgba(133, 133, 133, 0.12);
  border-radius: 4px;
  border: 1px solid rgba(231, 231, 233, 1);
  padding: 32px 50px 32px 58px;
  text-align: left;
  position: relative;
}
.process-frame h2 {
  float: left;
}
.process-frame-head {
  height: 32px;
}
.process-req {
  margin-top: 32px;
}
.process-req li {
  padding: 16px 0;
  border-bottom: 1px solid rgba(233, 233, 233, 1);
}
.liner {
  width: 40px;
  height: 2px;
  background: rgba(225, 227, 230, 1);
  margin: 14px auto;
}
.more {
  width: 60px;
  height: 22px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 22px;
  float: right;
  background: url(./images/arrow-right.png) 100% 50% no-repeat;
  background-size: 9%;
  cursor: pointer;
}
.requests {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(43, 51, 61, 1);
  line-height: 22px;
  margin-right: 156px;
}
.plus {
  width: 12px;
  height: 12px;
  float: right;
  background: url(./images/plus.png) 100% 50% no-repeat;
  background-size: 100%;
  cursor: pointer;
}
.active {
  width: 12px;
  height: 12px;
  float: right;
  background: url(./images/minus.png) 100% 50% no-repeat;
  background-size: 100%;
  cursor: pointer;
}
.process-show {
  margin-top: 7px;
  width: 320px;
  /* height:22px; */
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  /* line-height:22px; */
  display: block;
}
.process-hid {
  display: none;
}
.trangle {
  border-left: 10px solid transparent;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid rgba(255, 255, 255, 1);
  position: absolute;
  top: 20px;
  left: 0;
  margin-left: -20px;
}
.trangle:after {
  content: "";
  position: absolute;
  top: -10px;
  left: 10px;
  border-left: 10px solid transparent;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid rgba(231, 231, 233, 1);
  position: absolute;
  margin-left: -20px;
  z-index: -1;
  filter: blur(2px);
}
.senators {
  margin-top: -40px;
}
.senators-intro {
  width: 1064px;
  height: 572px;
  margin: 35px auto;
}
.senator {
  width: 498px;
  height: 572px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid rgba(236, 236, 237, 1);
  float: left;

  /* padding-bottom: 52px; */
}
.first {
  margin-right: 64px;
}
.senator-img {
  width: 120px;
  height: 120px;
  margin: 36px auto;
}
.senator-name {
  height: 24px;
  font-size: 28px;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: rgba(43, 51, 61, 1);
  line-height: 24px;
  margin-top: -6px;
}
.senator-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(43, 51, 61, 1);
  line-height: 26px;
  text-align: center;
  margin: 15px auto;
}
.senator-liner {
  width: 20px;
  height: 3px;
  background: rgba(251, 58, 77, 1);
  margin: 24px auto;
}
.senator-experience {
  margin-bottom: 32px;
}
.senator-experience .title {
  height: 24px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(43, 51, 61, 1);
  line-height: 24px;
}
.senator-experience .detail {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(119, 119, 129, 1);
  line-height: 23px;
  margin: 0 auto;
  text-align: center;
}
.cases {
  margin: 0 auto;
  margin-top: 100px;
  margin-bottom: 155px;
}
.cases .container {
  width: 1200px;
  height: 700px;
  margin: 0 auto;
  margin-top: 40px;
}
.case {
  float: left;
  width: 392px;
  height: 290px;
  margin-bottom: 48px;
}
.border {
  border-right: 1px solid rgba(223, 223, 223, 1);
  margin-right: 22px;
}
.last-case{
 width:370px;

}
.last-case .case-img{
  margin-left:0;
}
.case-img {
  width: 370px;
  height: 230px;
  margin-left: -19px;
}

.cases .title-ch {
  height: 24px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(43, 51, 61, 1);
  line-height: 24px;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 6px;
}
.case .title-en {
  height: 18px;
  font-size: 16px;
  font-family: Avenir-Book, Avenir;
  font-weight: normal;
  color: rgba(102, 102, 102, 1);
  line-height: 18px;
  text-align: left;
}
.cases .liner {
  margin-top: 27px;
}
.process-req .last {
  border: none;

}
img {
  width: 100%;
}

@media (max-width: 1440px) {
  .banner-small {
    display: block;
  }
  .banner-big {
    display: none;
  }
  .banner,
  .banner-img {
    height: 256px;
  }
}
@media (min-width: 1441px) {
  .banner-small {
    display: none;
  }
  .banner-big {
    display: block;
  }
  .banner,
  .banner-img {
    height: 335px;
  }
}
#ServiceBox1 {
  background: white;
  position: fixed;
  top: 30%;
  width: 120px;
  height: 251px;
  right: 26px;
  overflow: hidden;
  z-index: 100;
  box-shadow: 0 0 30px 0 rgba(229, 229, 229, 0.8);
  border-radius: 4px;
}
#ServiceBox1 .close-wrap {
  height: 16px;
  overflow: hidden;
}
#ServiceBox1-close {
  margin: 3px 3px 0 0;
  cursor: pointer;
  float: right;
  display: block;
  height: 16px;
  width: 16px;
  background: url(./images/ic_foldup_normal.png);
  background-size: 90%;
}
#ServiceBox1 .tel {
  font-family: PingFangSC-Regular;
  padding: 0 7px;
  color: #fb4254;
  font-size: 15px;
  text-align: center;
  margin: 10px auto 10px auto;
  display: block;
}
#weixinLogo {
  display: block;
  position: relative;
  font-weight: bold;
  text-decoration: none;
  color: #ffffff;
  width: 106px;
  height: 105px;
  margin: 10px auto 0 auto;
  line-height: 240px;
  padding: 0;
  background: url(./images/weixinAsk.png) -4px -19px no-repeat;
  font-size: 0;
}
.weixin-text {
  font-family: PingFangSC-Light;
  font-size: 12px;
  color: #a3a8ad;
  padding: 7px 7px 3px 7px;
  text-align: center;
  margin: 0 auto;
  display: block;
  line-height: 16px;
}
#onlineService {
  display: block;
  cursor: pointer;
}
#live800iconlink {
  position: relative;
  display: block;
  margin: 0 auto;
  font-weight: bold;
  text-decoration: none;
  text-align: center;
  color: #ffffff;
  width: 100px;
  height: 30px;
  line-height: 30px;
  padding: 0;
  font-size: 14px;
  color: #ffffff;
  background: #fb3a4c;
  border-radius: 4px;
}
#small-service-box {
  z-index: 101;
  position: fixed;
  top: 45%;
  right: 26px;
  cursor: pointer;
}
#small-service-box span {
  display: block;
  height: 68px;
  width: 68px;
  background: url(./images/ic_service_normal.png);
  background-size: 90%;
}
</style>
<style>
#YSF-BTN-HOLDER {
  visibility: hidden;
}
</style>
